import { StyleSheet } from 'aphrodite';
import theme from '~/src/theme';

export default StyleSheet.create({
  small: {
    fontSize: theme.fonts.size.small,
    lineHeight: '1.5em',
  },
});
